import * as React from 'react';
import classnames from 'classnames';
import { l10nError } from "../../helpers/l10nErrors";
import style from './FieldWrapper.scss';
import Error from "../Error";

export type Props = {
  className?: string,
  labelClassName?: string,
  label?: React.ReactNode,
  error?: string,
  errorAbsolute?: boolean,
  children?: React.ReactNode,
  containerTag?: 'div' | 'label',
};
type State = {};

export default class FieldWrapper extends React.PureComponent<Props, State> {
  render() {
    const {
      className,
      labelClassName,
      label,
      error,
      errorAbsolute,
      children,
      containerTag,
    } = this.props;
    const Container = containerTag || 'label';
    const containerClassName = classnames(
      style.container,
      className,
    )

    return (
      <Container className={containerClassName}>
        {label && <div className={classnames(style.label, labelClassName)}>{label}</div>}
        {children}
        {error && (
          <Error className={classnames(style.error, errorAbsolute && style.errorAbsolute)}>{l10nError(error)}</Error>
        )}
      </Container>
    );
  };
}
